"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HorizontalMovementComponent = void 0;
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var CONFIG = _interopRequireWildcard(require("../../config"));
var _isSpriteWithDynamicBody = require("../../../utils/is-sprite-with-dynamic-body");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
var _gameObject = /*#__PURE__*/new WeakMap();
var _inputComponent = /*#__PURE__*/new WeakMap();
var _velocity = /*#__PURE__*/new WeakMap();
class HorizontalMovementComponent {
  constructor(gameObject, inputComponent, velocity) {
    var _classPrivateFieldGet2, _classPrivateFieldGet3, _classPrivateFieldGet4;
    _classPrivateFieldInitSpec(this, _gameObject, void 0);
    _classPrivateFieldInitSpec(this, _inputComponent, void 0);
    _classPrivateFieldInitSpec(this, _velocity, void 0);
    _classPrivateFieldSet(_gameObject, this, gameObject);
    _classPrivateFieldSet(_inputComponent, this, inputComponent);
    _classPrivateFieldSet(_velocity, this, velocity);
    if (!(0, _isSpriteWithDynamicBody.isSpriteWithDynamicBody)(_classPrivateFieldGet(_gameObject, this).body)) {
      return;
    }
    (_classPrivateFieldGet2 = _classPrivateFieldGet(_gameObject, this).body) === null || _classPrivateFieldGet2 === void 0 || _classPrivateFieldGet2.setDamping(true);
    (_classPrivateFieldGet3 = _classPrivateFieldGet(_gameObject, this).body) === null || _classPrivateFieldGet3 === void 0 || _classPrivateFieldGet3.setDrag(CONFIG.COMPONENT_MOVEMENT_HORIZONTAL_DRAG);
    (_classPrivateFieldGet4 = _classPrivateFieldGet(_gameObject, this).body) === null || _classPrivateFieldGet4 === void 0 || _classPrivateFieldGet4.setMaxVelocity(CONFIG.COMPONENT_MOVEMENT_HORIZONTAL_MAX_VELOCITY);
  }
  reset() {
    var _classPrivateFieldGet5;
    if (!(0, _isSpriteWithDynamicBody.isSpriteWithDynamicBody)(_classPrivateFieldGet(_gameObject, this).body)) {
      return;
    }
    _classPrivateFieldGet(_gameObject, this).body.velocity.x = 0;
    (_classPrivateFieldGet5 = _classPrivateFieldGet(_gameObject, this).body) === null || _classPrivateFieldGet5 === void 0 || _classPrivateFieldGet5.setAngularAcceleration(0);
  }
  update() {
    if (!(0, _isSpriteWithDynamicBody.isSpriteWithDynamicBody)(_classPrivateFieldGet(_gameObject, this).body)) {
      return;
    }
    if (_classPrivateFieldGet(_inputComponent, this).leftIsDown) {
      if (_classPrivateFieldGet(_gameObject, this).body) {
        _classPrivateFieldGet(_gameObject, this).body.velocity.x -= _classPrivateFieldGet(_velocity, this);
      }
    } else if (_classPrivateFieldGet(_inputComponent, this).rightIsDown) {
      if (_classPrivateFieldGet(_gameObject, this).body) {
        _classPrivateFieldGet(_gameObject, this).body.velocity.x += _classPrivateFieldGet(_velocity, this);
      }
    } else {
      var _classPrivateFieldGet6;
      (_classPrivateFieldGet6 = _classPrivateFieldGet(_gameObject, this).body) === null || _classPrivateFieldGet6 === void 0 || _classPrivateFieldGet6.setAngularAcceleration(0);
    }
  }
}
exports.HorizontalMovementComponent = HorizontalMovementComponent;